import PropTypes from 'prop-types'
import React from 'react'
import ReactSVG from 'react-svg'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'

const TOP_TAG_KEYS = ['discount', 'installment']

const getVisibleImageTags = (imageTags) => {
  if (!Array.isArray(imageTags)) return []
  return imageTags?.filter(tag => tag?.show)
}

const bg = (tag) => tag.background_color || tag.backgroundColor
const tc = (tag) => tag.text_color || tag.textColor

const getTopTags = (visibleTags) => {
  const topTags = []

  visibleTags.forEach(tag => {
    if (tag.key === 'discount' && tag.text) {
      const [amount, ...rest] = tag.text.split(/\s+/)
      topTags.push({
        key: tag.key,
        order: tag.order,
        amount: amount || '',
        label: rest.join(' ') || '',
        backgroundColor: bg(tag),
        textColor: tc(tag),
        opacity: tag.opacity,
        type: 'badge'
      })
    }

    if (tag.key === 'installment' && tag.badge) {
      const { badge } = tag
      topTags.push({
        key: `${tag.key}-badge`,
        order: badge.order ?? tag.order,
        unitMonthlyAmount: badge.unitMonthlyAmount,
        label: badge.label,
        backgroundColor: bg(badge),
        textColor: tc(badge),
        opacity: badge.opacity,
        type: 'badge'
      })
    }
  })

  return topTags.sort((a, b) => a.order - b.order)
}

const getBottomTags = (visibleTags) => {
  const bottomTags = []

  visibleTags.forEach(tag => {
    if (tag.key === 'installment') {
      if (tag.text) {
        bottomTags.push({
          key: `${tag.key}-text`,
          order: tag.order,
          text: tag.text,
          backgroundColor: bg(tag),
          textColor: tc(tag),
          opacity: tag.opacity
        })
      }
      return
    }

    if (TOP_TAG_KEYS.includes(tag.key)) return

    if (tag.text) {
      bottomTags.push({
        key: tag.key,
        order: tag.order,
        text: tag.text,
        backgroundColor: bg(tag),
        textColor: tc(tag),
        opacity: tag.opacity
      })
    }
  })

  return bottomTags.sort((a, b) => a.order - b.order)
}

export const ItemImage = ({ img, isPromoted, title, as, href, tire_season_slug, imageTags }) => {
  const { t } = useTranslation('common')

  const visibleTags = getVisibleImageTags(imageTags)
  const topTags = getTopTags(visibleTags)
  const bottomTags = getBottomTags(visibleTags)

  return (
    <div className='ads-list-item-image-container'>
      <Link href={href} as={as}>
        <a>
          <img src={img} alt={title} style={{ objectFit: 'cover' }} />

          {/* <div className='ad-status'>
            {isPromoted ? (
              <div className='ad-status__item ad-status__item_vehicle-part-paid'>
                {t('auto djelovi').toUpperCase()}
              </div>
            ) : ''}
          </div> */}

          <div className='vehicle-part-image-season-icon'>
            {tire_season_slug?.slug === 'zimska' ? (
              <ReactSVG src={`/icons/guma-zimska.svg`} className='vehicle-part-image-season-icon__wrapper' beforeInjection={(svg) => {
                svg.setAttribute('width', '20px')
                svg.setAttribute('height', '20px')
              }} />
            ) : null}

            {tire_season_slug?.slug === 'ljetnja' ? (
              <ReactSVG src={`/icons/guma-ljetnja.svg`} className='vehicle-part-image-season-icon__wrapper' beforeInjection={(svg) => {
                svg.setAttribute('width', '20px')
                svg.setAttribute('height', '20px')
              }} />
            ) : null}

            {tire_season_slug?.slug === 'all-season' ? (
              <ReactSVG src={`/icons/guma-univerzalna.svg`} className='vehicle-part-image-season-icon__wrapper' beforeInjection={(svg) => {
                svg.setAttribute('width', '20px')
                svg.setAttribute('height', '20px')
              }} />
            ) : null}
          </div>

          {topTags.length ? (
            <div className='vp-list-image-tags vp-list-image-tags--top'>
              {topTags.map(tag => (
                <div
                  key={tag.key}
                  className='vp-list-image-tag vp-list-image-tag--badge'
                  style={{
                    backgroundColor: tag.backgroundColor,
                    color: tag.textColor,
                    opacity: tag.opacity
                  }}
                >
                  <span className='vp-list-image-tag__amount'>
                    {tag.unitMonthlyAmount != null
                      ? `${tag.unitMonthlyAmount}€`
                      : (tag.amount || '')}
                  </span>
                  <span className='vp-list-image-tag__label'>{tag.label || ''}</span>
                </div>
              ))}
            </div>
          ) : null}

          {bottomTags.length ? (
            <div className='vp-list-image-tags vp-list-image-tags--bottom'>
              {bottomTags.map(tag => (
                <div
                  key={tag.key}
                  className='vp-list-image-tag'
                  style={{
                    backgroundColor: tag.backgroundColor,
                    color: tag.textColor,
                    opacity: tag.opacity
                  }}
                >
                  {tag.text}
                </div>
              ))}
            </div>
          ) : null}
        </a>
      </Link>
    </div>
  )
}

ItemImage.propTypes = {
  img: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  as: PropTypes.string,
  href: PropTypes.string,
  imageTags: PropTypes.array
}
